import { escapeHtml } from "../../utils/escapeHtml";

/**
 * HTML of the popup shown while a Moodle course opens. Every value is escaped: the course name is user-entered API
 * data (entity-decoded by api/request.ts) and the popup is a same-origin about:blank window.
 */
export const getMoodleLoadingPage = (rawTitle: string, rawMessage: string, rawCourseName: string): string => {
  const title = escapeHtml(rawTitle);
  const message = escapeHtml(rawMessage);
  const courseName = escapeHtml(rawCourseName);
  return `
    <!DOCTYPE html>
    <html>
      <head>
        <title>${title}</title>
        <style>
          body {
            margin: 0;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
            background: linear-gradient(135deg, #556e8b 0%, #6b7fa0 100%);
          }
          .loader-container {
            text-align: center;
            color: white;
          }
          .spinner {
            border: 4px solid rgba(255, 255, 255, 0.3);
            border-top: 4px solid #f0ad4e;
            border-radius: 50%;
            width: 50px;
            height: 50px;
            animation: spin 1s linear infinite;
            margin: 0 auto 20px;
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          h2 {
            margin: 0;
            font-size: 24px;
            font-weight: 500;
          }
          p {
            margin: 10px 0 0 0;
            font-size: 14px;
            opacity: 0.9;
          }
          .course-name {
            margin-top: 20px;
            font-size: 16px;
            font-weight: 600;
            opacity: 1;
          }
        </style>
      </head>
      <body>
        <div class="loader-container">
          <div class="spinner"></div>
          <h2>${title}</h2>
          <p>${message}</p>
          <p class="course-name">${courseName}</p>
        </div>
      </body>
    </html>
  `;
};
